import getUF from './get-uf.js';

var getFullAddress = (rawAddress, glossary) => {
  if (!rawAddress) return null;

  const {
    street: rawStreet,
    streetNumber: rawStreetNumber,
    neighborhood: rawNeighborhood,
    city: rawCity,
    state: rawState,
  } = rawAddress;

  const streetNumber = rawStreetNumber ? `, ${rawStreetNumber}` : '';
  const street = rawStreet ? `${rawStreet}${streetNumber} -` : '';
  const neighborhood = rawNeighborhood ? `${rawNeighborhood},` : '';
  const city = rawCity ? `${rawCity} -` : '';
  const state = rawState ? `${getUF(rawAddress, glossary)}` : '';

  return [street, neighborhood, city, state]
    .filter(Boolean)
    .join(' ')
    .replace(/\s?-$/, '');
};

export { getFullAddress as default };
//# sourceMappingURL=get-full-address.js.map
